export default __webpack_public_path__ + "static/media/ring_song.cf0390ab.mp3";